import { render, staticRenderFns } from "./WFHEdit.vue?vue&type=template&id=8e8de978&"
import script from "./WFHEdit.vue?vue&type=script&lang=js&"
export * from "./WFHEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports